import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { AppMenu } from "./AppMenu";

/** Authenticated chrome: fixed-height menu + main area (legacy wrapper/main). */
export function AppShell() {
  // Warm the editor chunk (CodeMirror) in the background once signed in, so the first
  // project-open is instant rather than downloading ~220 KB then.
  useEffect(() => {
    const warm = () => void import("@/editor/EditorPage");
    const w = window as unknown as { requestIdleCallback?: (cb: () => void) => void };
    if (w.requestIdleCallback) w.requestIdleCallback(warm);
    else setTimeout(warm, 1500);
  }, []);

  return (
    <div className="flex h-full flex-col overflow-hidden bg-ide-dark">
      <AppMenu />
      <div className="main relative min-h-0 flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}
